var map = {
	"./demos/basic/index.ts": 73532,
	"./demos/extra/index.ts": 90530,
	"./demos/grid/index.ts": 96853,
	"./demos/noHeader/index.ts": 47750,
	"./demos/size/index.ts": 68368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18987;